import { render, staticRenderFns } from "./assessment-result-card.component.vue?vue&type=template&id=2798642b&scoped=true&"
import script from "./assessment-result-card.component.vue?vue&type=script&lang=ts&"
export * from "./assessment-result-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-result-card.component.vue?vue&type=style&index=0&id=2798642b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2798642b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VIcon,VProgressCircular,VRow,VTooltip})
